import * as ImgCache from 'imgcache.js'
import { timeout } from '../../../shared/lib/timeout.no-deps'
import { globalHive } from '../../src/modules/hive'
import { clearData } from '../../src/redux/actions/common'
import ActivityStore from '../../src/stores/activity'
import LocationStore from '../../src/stores/location'
import PlannerStore from '../../src/stores/planner'
import * as sentry from '../../src/utils/sentry'
import { Cust_canCleanupFlowImages } from '../Cust/Cust.serverPrefs'
import { DS_getData, DS_getInitialData, DS_setData } from '../DS/DS.Data'
import { IDB_cachedImages, clearUploads } from '../IDB/IDB.deviceDB'
import { IDB_reset } from '../IDB/IDB.reset'
import { LS_authUrlGet, LS_authUrlSet } from '../LS/LS.authUrl'
import { LS_migrate } from '../LS/LS.migrate'
import { Plat_isCordova } from '../Plat/Plat.device'
import { Sync_stop } from '../Sync/Sync.initialise'
import * as UserProfileImageCache from '../User/UserProfileImageCache'
import { Auth_pendoLogout } from './Auth.pendo'

export async function Auth_cleanse() {
    try {
        // Do not try to do twice
        if (DS_getData().cleanse.status !== 'ready') return

        // Show the user a spinner
        DS_setData('CleanseInitiated', () => ({ cleanse: { status: 'in-progress' } }))

        // Stop sync from happening
        Sync_stop()

        // Trigger async effects
        const idbResetP = IDB_reset()
        const imgCacheP = new Promise((resolve, reject) => ImgCache.clearCache(resolve, reject))

        if (!Plat_isCordova()) {
            await clearUploads()
        }

        const shouldCleanUpCachedFlowImages = Cust_canCleanupFlowImages()
        const authUrl = LS_authUrlGet()

        // Clear out data synchronously
        globalHive.logout()
        localStorage.clear()
        globalHive.dispatch(clearData())
        PlannerStore.deleteStoreData()
        ActivityStore.deleteStoreData()
        LocationStore.deleteStoreData()
        DS_setData('CleanseDataCleared', ({ auth, safeLogout }) => ({
            ...DS_getInitialData(),
            cleanse: { status: 'in-progress' },
            onLoad: { status: 'success' },
            auth,
            safeLogout,
        }))

        // Migrate the localStorage again so that it has the correct lStorageVersion in it
        LS_migrate()

        // Remove user and customer from telemetry
        sentry.logout()
        Auth_pendoLogout()

        // Try to wait for async but ignore failure
        try {
            await Promise.race([imgCacheP, timeout(3000)])
        } catch (error) {
            sentry.err(error, {})
        }

        // Do not ignore if it fails to reset database
        await idbResetP

        UserProfileImageCache.clearCache()

        if (shouldCleanUpCachedFlowImages) {
            await IDB_cachedImages().clear()
        }

        if (authUrl) LS_authUrlSet(authUrl)

        // Hide the spinner
        DS_setData('CleanseSuccess', () => ({ cleanse: { status: 'ready' } }))
    } catch (error) {
        // Show an error screen
        DS_setData('CleanseFailed', () => ({
            cleanse: { status: 'failure', error },
        }))

        throw error
    }
}
